<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Стикеры</h4>
                            <p class="card-category"></p>
                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="categoryId" id="category-filter"
                                                @change="saveFilters('gr_category', categoryId)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option v-for="c in categories" v-bind:value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="status" id="status-filter"
                                                @change="saveFilters('gr_status', status)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">Активен</option>
                                            <option value="0">Не активен</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Поиск по ID"
                                              v-model="filteredId"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Поиск по src"
                                              v-model="filteredSrc"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Добавить стикер
                                    </button>
                                </div>
                            </div>

                        </template>
                        <div class="table-responsive">
                            <table class="table" v-bind:class="{ 'loading-state': loading }">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'sort'">сортировка</span>
                                        <span v-else-if="column === 'category'">категория</span>
                                        <span v-else-if="column === 'src_full'">стикер</span>
                                        <span v-else-if="column === 'no_color'">доступно для редактирования</span>
                                        <span v-else-if="column === 'status'">статус</span>
                                        <span v-else-if="column === 'translations'">переводы</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <span v-if="column === 'translations'">{{ item[column] }}</span>
                                            <div v-else-if="column === 'src'" @click="edit(item['id'])">
                                                <img :src="`${graphicsUrl}${item[column]}`" class="device-block device1">
                                            </div>
                                            <span v-else-if="column === 'no_color'">
                                                <img class="no-color" src="/static/img/ok.png" v-if="item[column] !== 1"/>
                                            </span>
                                            <span v-else-if="column === ''">
                                                <a class="text-primary" @click="edit(item['id'])">Изменить</a>
                                                <img class="new-tab" src="/static/img/new-tab.png" @click="openNewTab(item['id'])"/>
                                              </span>
                                                                    <span v-else-if="column === 'status'">
                                                <span class="text-success" v-if="item[column] === 1">Активен</span>
                                                <span class="text-warning" v-if="item[column] === 0">Не активен</span>
                                              </span>
                                            <span v-else>{{ item[column] }}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            След.
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Пред.
                        </div>
                    </card>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";

const axios = require('axios')
import LTable from 'src/components/UIComponents/Table.vue'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        LTable,
        Card
    },
    created: function () {
        let self = this;

        let token = localStorage.getItem('token');

        axios.get(
            `${this.$hostname}/admin/graphics/categories/`,
            {
                'params': {

                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.loading = false;
                self.categories = response.data;

                self.get();
            })
            .catch(function (error) {
                self.loading = false;
                console.log(error)
            });
    },
    data() {
        return {
            columns: ['id', 'category', 'src', 'no_color', 'sort', 'status', ''],
            data: [],
            status: localStorage.getItem('gr_status') ? localStorage.getItem('gr_status') : "",
            categoryId: localStorage.getItem('gr_category') ? localStorage.getItem('gr_category') : "",
            filteredId: null,
            filteredSrc: null,
            categories: [],
            loading: false,
            limit: 10,
            offset: parseInt(localStorage.getItem('gr_active_offset')) || 0,
        }
    },
    computed: {
        graphicsUrl() {
            return this.$graphicsUrl
        },
    },
    methods: {
        init: function () {
            this.get()
        },
        filter: function () {
            localStorage.setItem('gr_active_offset', "0");
            this.offset = 0;

            this.get();
        },
        prev: function () {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('gr_active_offset', parseInt(this.offset));
            }
        },
        next: function () {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('gr_active_offset', parseInt(this.offset));
            }
        },
        add: function () {
            this.$router.push('/graphics/create');
        },
        get: function () {
            let self = this;

            let token = localStorage.getItem('token');
            let filteredId = this.filteredId === null ? '' : this.filteredId;
            let filteredSrc = this.filteredSrc === null ? '' : this.filteredSrc;
            //this.loading = true;

            axios.get(
                `${this.$hostname}/admin/graphics/`,
                {
                    'params': {
                        limit: self.limit,
                        offset: self.offset,
                        status: this.status,
                        categoryId: this.categoryId,
                        filteredId: filteredId,
                        filteredSrc: filteredSrc,
                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.data = response.data;
                    self.loading = false;
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                })
        },
        edit: function (id) {
            this.$router.push({
                name: 'edit-graphic',
                params: {id: id}
            });
        },
        openNewTab: function (id) {
            if (this.role === 2) {
                return false;
            }
            const routeData = this.$router.resolve({
                name: 'edit-graphic',
                params: { id: id }
            });

            window.open(routeData.href, '_blank');
        },
        saveFilters: function(name, value) {
            localStorage.setItem(name, value);
        },
    },
    beforeRouteLeave (to, from , next) {
        if (to.path.indexOf('graphics') < 1) {
            localStorage.setItem('gr_category', "");
            localStorage.setItem('gr_status', "");
            localStorage.setItem('gr_active_offset', "0");
        }
        next();
    },
}
</script>
<style scoped>
.pagination-button {
    height: 30px;
    padding: 1px 16px;
    margin-left: 20px;
    color: #fff !important;
}
.pagination-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.mt10 {
    margin-top: 10px;
}
.device1 {
    display: block;
    max-width: 100%;
    max-height: 64px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-color: transparent;
}
.no-color {
    width: 30px;
    margin-left: 20px;
}
img {
    max-width: 100% !important;
}
.btn-fill {
    margin-top: 25px;
}
.text-primary {
    cursor: pointer;
}
th {
    padding: 12px 8px;
}
.text-default {
    cursor: pointer;
    color: #000;
}
.text-success, .text-warning {
    font-weight: 700 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Graphics.vue